// components
import GridPageAbstract from '../../GridPageAbstract';
import { ScanBarcodeBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';
import i18n from '../../../i18';
import { AddCircleWhiteLinearIcon } from '../../../icons-lib';
import CustomAddXDialog from '../../dialogs/CustomAddXDialog';
import i18 from '../../../i18';

export default class InviteCodesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'inviteCodes';
        this.Server = this.props.context.getState().server.inviteCodes;

        this.headerStartIcon = ScanBarcodeBulkIcon;
        this.bannerImage = config?.bannerImages?.wallets || '';
        this.hideAddAction = true;
        this.getHeaderActions = () =>
            [
                this.allowedPermission('create') && {
                    title: i18n.t('actions.addInviteCodes'),
                    icon: <AddCircleWhiteLinearIcon />,
                    onClick: () => this.handleOpenAddInviteCodesDialog()
                }
            ].filter(Boolean);
        this.getToolbarActions = () =>
            [
                {
                    title: i18.t('buttons.downloadPdf'),
                    onClick: () => this.handleDownloadPdf()
                }
            ].filter(Boolean);

        this.searchFields = [
            'codeNumber',
            'merchant.name',
            'coin.name',
            'secret'
        ];

        this.hiddenColumns = config?.hiddenColumns?.inviteCodes || [];

        this.Head = [
            {
                id: 'codeNumber',
                label: 'codeNumber',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'coinId',
                label: 'coin',
                alignRight: false,
                cell: 'Select',
                object: 'coin',
                from: 'coins',
                display: 'name',
                filterCell: 'Context',
                filterBy: 'coins'
            },
            {
                id: 'quantity',
                label: 'quantity',
                alignRight: false,
                cell: 'Number',
                disableGrid: true
            },
            {
                id: 'secret',
                label: 'secret',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'isClaimed',
                label: 'isClaimed',
                alignRight: false,
                cell: 'Boolean',
                object: 'merchant',
                trueLabel: 'claimed',
                falseLabel: 'notClaimed',
                disableEditor: true,
                filterCell: 'Existence',
                filterField: 'merchant'
            },
            {
                id: 'merchant',
                label: 'merchant',
                alignRight: false,
                cell: 'Text',
                object: 'merchant',
                display: 'name',
                disableEditor: true
            },
            {
                id: 'walletNumber',
                label: 'walletNumber',
                alignRight: false,
                cell: 'Text',
                display: 'walletNumber',
                nested: 'merchant.location',
                disableEditor: true
            },
            {
                id: 'dateExpiry',
                label: 'dateExpiry',
                alignRight: false,
                cell: 'FullDate',
                filterCell: 'Date'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }

    handleOpenAddInviteCodesDialog() {
        this.setState({ openAddInviteCodesDialog: true });
    }
    handleCloseAddInviteCodesDialog() {
        this.setState({ openAddInviteCodesDialog: false });
    }
    handleSaveAddInviteCodesDialog() {
        this.setState({ openAddInviteCodesDialog: false });
        this.retrieveData();
    }
    renderCustom() {
        return (
            <CustomAddXDialog
                dialogOpen={this.state.openAddInviteCodesDialog}
                head={this.Head}
                title={i18n.t('text.addInviteCodes')}
                server={this.Server}
                onClose={() => this.handleCloseAddInviteCodesDialog()}
                onSave={() => this.handleSaveAddInviteCodesDialog()}
            />
        );
    }
}
